import { loadable } from '@change/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-bandit-details',
		path: '/dashboard/bandit/variant_group/:slug',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin_bandit_details" */ './index'), {
			exportName: 'AdminBanditDetails',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: 'staff',
		},
		frame: true,
		ssr: {
			enabled: true,
			seo: false,
		},
	},
];
